import { Injectable } from '@angular/core';
import { DataTaskService } from '../core/services/data-task.service';
import { BehaviorSubject } from 'rxjs';
import { UserService } from '@app/core/services/user.service';
import { UserStore } from '@app/core/services/user.store';
@Injectable({
    providedIn: 'root',
})
export class ThemeService {
    private themeModeSubject = new BehaviorSubject<'dark' | 'light'>('light');

    public themeMode$ = this.themeModeSubject.asObservable();

    constructor(
        private datatask: DataTaskService,
        private user: UserStore,
    ) {
        user.themeKeynoMobileChanged.subscribe({ next: (value) => this.themeModeSubject.next('' + value === '1' ? 'light' : 'dark') });
        user.themeKeynoChanged.subscribe({ next: (value) => this.themeModeSubject.next('' + value === '1' ? 'light' : 'dark') });
    }

    public setThemeMode(mode: 'dark' | 'light') {
        this.themeModeSubject.next(mode);
    }

    public toggleDarkMode() {
        const mode = this.themeModeSubject.getValue() === 'dark' ? 1 : 2;

        if (window.matchMedia('(min-width: 768px)').matches === true) {
            this.user.setThemeKeyno(mode);

            this.saveTheme({ theme_keyno: mode, screensize: 'big' });
            // ttNavbarService.saveThemeSetting('big', mode);
        } else {
            this.user.setThemeKeynoMobile(mode);
            this.saveTheme({ theme_keyno: mode, screensize: 'small' });
            // ttNavbarService.saveThemeSetting('small', mode);
        }

        // if (document.getElementsByTagName('html')?.[0].classList.contains('dark')) {
        //     vm.model.darkmode = true;
        // } else {
        //     vm.model.darkmode = false;
        // }
    }

    private async saveTheme(params: SaveThemeParams) {
        return this.datatask.Post(3094, params);
    }

    /**
     * Returns a promise containg a list of available TouchTime themes.
     *
     * @returns a promise containing a list of available TouchTime themes.
     */
    public getThemes(): Promise<TouchTimeTheme[]> {
        return this.datatask.Post(3047);
    }
}

interface SaveThemeParams {
    screensize: 'big' | 'small';
    theme_keyno: `${number}` | number;
}

export interface TouchTimeTheme {
    theme_name: string;
    theme_keyno: string;
    system_name: string;
    color_scheme: string;
}
